import { ArrowButton } from 'components/Buttons'
import { Overline, Subtitle, Subtitle2 } from 'components/Text'
import React from 'react'
import styled from 'styled-components'
import Colors from 'styles/Colors'
import media from 'styles/media'

import { ReactComponent as IllustrationSVG } from 'svg/whitepaperIllustration.svg'
import { ReactComponent as TitleSVG } from 'svg/whitepapers.svg'
import whitePaper1 from 'pdf/RTR_WP-1-Programming-Reduced.pdf'
import whitePaper2 from 'pdf/RTR_WP-2-Improved-Throughput.pdf'
import whitePaper3 from 'pdf/RTR_WP-3-Optimization-Core-Results.pdf'
import whitePaper4 from 'pdf/RTR_WP-4-Failure-Recovery.pdf'

const Whitepapers: React.FC<{}> = () => {
  return (
    <Wrapper>
      <Illustration />
      <SectionTitle />
      <a
        href={whitePaper1}
        aria-label="Accelerating Your Deployment of Multi-Robot Workcells Whitepaper"
        target="_blank"
        rel="noreferrer noopener"
      >
        <Button>
          <Text>
            <Title>Accelerating Your Deployment of Multi-Robot Workcells</Title>
            <Label>Realtime Robotics</Label>
            <Label2>Whitepaper</Label2>
          </Text>
          <Download>Download</Download>
        </Button>
      </a>
      <a
        href={whitePaper2}
        aria-label="Improving Throughput Whitepaper"
        target="_blank"
        rel="noreferrer noopener"
      >
        <Button>
          <Text>
            <Title>Improving Throughput</Title>
            <Label>Realtime Robotics</Label>
            <Label2>Whitepaper</Label2>
          </Text>
          <Download>Download</Download>
        </Button>
      </a>
      <a
        href={whitePaper3}
        aria-label="Advancing Implementation Whitepaper"
        target="_blank"
        rel="noreferrer noopener"
      >
        <Button>
          <Text>
            <Title>Advancing Implementation</Title>
            <Label>Realtime Robotics</Label>
            <Label2>Whitepaper</Label2>
          </Text>
          <Download>Download</Download>
        </Button>
      </a>
      <a
        href={whitePaper4}
        aria-label="Efficient Automated Recovery Whitepaper"
        target="_blank"
        rel="noreferrer noopener"
      >
        <Button>
          <Text>
            <Title>Efficient Automated Recovery</Title>
            <Label>Realtime Robotics</Label>
            <Label2>Whitepaper</Label2>
          </Text>
          <Download>Download</Download>
        </Button>
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;
  height: 820px;
  padding-top: 204px;
  padding-left: 348px;
  ${media.tabletLandscape} {
    height: 1086px;
    padding-top: 446px;
    // padding-left: calc(50% - 249px);
    padding-left: 0px;
  }
  ${media.mobile} {
    padding-left: 12px;
    padding-top: 338px;
    height: 978px;
  }
`
const Button = styled.div`
  width: 58.5vw;
  min-height: 120px;
  margin-bottom: 24px;
  background: white;
  padding: 22px 141px 24px 79px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.tabletLandscape} {
    width: 498px;
    width: calc(100% - 270px);
    margin-left: 135px;
    padding: 24px 218px 21px 38px;
  }
  ${media.mobile} {
    margin-left: 0;
    width: calc(100% - 24px);
    padding: 24px 126px 21px 38px;
  }
`
const Text = styled.div``
const Title = styled(Subtitle)`
  position: relative;
  ::before {
    content: '//';
    position: absolute;
    color: ${Colors.rossoCorsa};
    left: -31px;
  }
  ${media.tabletLandscape} {
    font-size: 16px;
    font-weight: bold;
    ::before {
      left: -22px;
    }
  }
`
const Label = styled(Subtitle2)`
  opacity: 0.4;
  margin-top: 6px;
`
const Label2 = styled(Overline)``
const Download = styled(ArrowButton)`
  position: absolute;
  top: 52px;
  right: 48px;
  transition: 0.4s;
  transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
  :hover {
    right: 44px;
  }
  padding: 0;
  ${media.tabletLandscape} {
    font-size: 16px;
  }
  ${media.mobile} {
    right: 16px;
    :hover {
      right: 12px;
    }
  }
`
const Illustration = styled(IllustrationSVG)`
  width: 23.8vw;
  position: absolute;
  top: 0;
  left: 70.5vw;
  ${media.tabletLandscape} {
    transform: scaleX(-1);
    left: auto;
    right: 14px;
    top: 74px;
    width: 310px;
  }
  ${media.mobile} {
    width: 200px;
    top: 83px;
  }
`
const SectionTitle = styled(TitleSVG)`
  position: absolute;
  height: 449px;
  left: 96px;
  top: 307px;
  ${media.tabletLandscape} {
    height: 302px;
    left: 41px;
    top: 96px;
  }
  ${media.mobile} {
    top: 94px;
    height: 202px;
    left: 12px;
  }
`
export default Whitepapers
